import React from "react";
import {AutoComplete, Button, Checkbox, Form, Icon, Input, Select, Row, Col, Typography} from "antd";
import {Link} from "react-router-dom";
import _ from 'lodash';
import code from "../util/code.json"
import {connect} from "react-redux";
import {
  hideMessage,
  showAuthLoader,
  userFacebookSignIn,
  userGithubSignIn,
  userGoogleSignIn,
  userSignUp,
  userTwitterSignIn,
  userSignIn,
} from "appRedux/actions/Auth";

import IntlMessages from "util/IntlMessages";
import {message} from "antd/lib/index";
import CircularProgress from "components/CircularProgress/index";
import "./signup.less"
import {getData, fetchBank, createUser} from '../util/API'

const FormItem = Form.Item;
const Option = Select.Option;
const AutoCompleteOption = AutoComplete.Option;
const country_code= code.map((x,index) =>  <Option key={index}  value={x.dial_code}>{x.code}</Option> )
const { Text, Title } = Typography;


class ClientSignUp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      token : localStorage.getItem('token')?localStorage.getItem('token'):null,
      cloader : false,
      agentData: null
    };

    if (this.state.token != null) {
      this.props.history.push('/signin');
    }
  }

  componentDidMount() {
  }


  titleCasing = (e) => {
    let str = e.target.value   
    let splitStr = str.split(' ');
        for (let i = 0; i < splitStr.length; i++) {
            // You do not need to check if i is larger than splitStr length, as your for does that for you
            // Assign it back to the array
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
        }
        // Directly return the joined string
        e.target.value = splitStr.join(' '); 
  }

   handleSubmit = (e) => {

    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      // console.log("err -> ", err);
      if (!err) {
          console.log(values)
      this.setState({cloader: true});
       const user = {
        email: values.email,
        phone: values.prefix + values.phone ,
        designation: values.designation,
        name: values.client,
        full_name: values.name
      };
      const endpoint = '/finance/client-users-create/'
      createUser(endpoint, user)
      .then(res => {
        if (res.data['status']==200)
        {
        localStorage.setItem('token', res.data['token']);
        localStorage.setItem('uuid', res.data['uuid']);
        localStorage.setItem('user_uuid', res.data.uuid)
        localStorage.setItem('user_role', res.data['user_role']);
        this.props.history.push('/client-project-list');
        } else {
          this.setState({cloader: false});
          message.error(res.data['message'])
        }
      })
      .catch(error => {
        this.setState({cloader: false});
        console.log(error);
        message.error(error.toString())
      });

      }
    });
  };

  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 100);
    }
    if (this.state.token != null) {
      this.props.history.push('/signin');
    }
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {showMessage, loader, alertMessage} = this.props;
    const prefixSelector = getFieldDecorator('prefix', {
      initialValue: '+91',
    })(
      <Select key = 'sel' style={{width: 70}}>
       {country_code}
      </Select>
    );
    // let dataSource = _.map(this.state.agentData, 'full_name')
    let dataSource = this.state.agentData;
    return (
      <div className="gx-app-login-wrap">
      <div className="gx-app-login-container">
        <Row type="flex" align="middle" className="gx-app-login-main-content">
            <Col xl={12} lg={24} md={24} sm={24} xs={24} className="emptySpacing">
              <div className="gx-app-logo-content">
                <div className="gx-app-logo-content-bg">
                  <img src={require('assets/images/jetty-welcome-cropped.jpg')} alt='Neature'/>
                </div>
              </div>
            </Col>
            <Col xl={12} lg={24} md={24} sm={24} xs={24} className="emptySpacing">
              <div className="gx-app-login-content">
              <Title level={2}>Join the club</Title>
              <Text style={{fontSize:'18px'}}>Orion22 is the marketplace for Uniserved Partners to showcase their skills and work on projects with the biggest names in the Industry.</Text>
                <Form onSubmit={this.handleSubmit} className="gx-signup-form gx-form-row0 gx-mt-4">
                  <FormItem label={(
                    <span>
                    Associated Client

                  </span>
                  )}>
                    {getFieldDecorator('client', {
                      rules: [{required: true, message: 'Please fill this field!'}],
                    })(
                        <Input placeholder="Associated Client" onChange={this.titleCasing}/>
                    )}
                  </FormItem>

                  <FormItem label={(
                    <span>
                    Name

                  </span>
                  )}>
                    {getFieldDecorator('name', {
                      rules: [{
                        required: true, message: 'The input is not valid E-mail!',
                      }],
                    })(
                      <Input placeholder="Client Name"  onChange={this.titleCasing}/>
                    )}
                  </FormItem>

                  <FormItem label={(
                    <span>
                    Phone

                  </span>
                  )}>
                    {getFieldDecorator('phone', {
                      rules: [{required: true, message: 'Please input your phone number!'}],
                    })(
                      <Input addonBefore={prefixSelector} style={{width: '100%'}}/>
                    )}
                  </FormItem>
                  
                  <FormItem label="Email"                 
                  >
                    {getFieldDecorator('email', {
                      rules: [{
                        required: true, type: 'email', message: 'The input is not valid E-mail!',
                      }],
                    })(
                      <Input placeholder="Email"/>
                    )}
                  </FormItem>
                  <FormItem label="Designation">
                    
                    {getFieldDecorator('designation', {
                      rules: [{required: true, message: 'Please input your Designation!'}],
                    })(
                      <Input placeholder="Designation" onChange={this.titleCasing}/>
                    )}
                  </FormItem>
                  
                  <br></br>
                  <FormItem>
                    <Button type="primary" className="gx-mb-0" htmlType="submit">
                      <IntlMessages id="app.userAuth.signUp"/>
                    </Button>
                    <span><IntlMessages id="app.userAuth.or"/></span> <Link to="/client"><IntlMessages
                    id="app.userAuth.signIn"/></Link>
                  </FormItem>

                </Form>
              </div>
              {this.state.cloader &&
              <div className="gx-loader-view">
                <CircularProgress/>
              </div>
              }
              {showMessage &&
              message.error(alertMessage)}
            </Col>
        </Row>
      </div>
      </div>
    );
  }

}

const WrappedSignUpForm = Form.create()(ClientSignUp);

const mapStateToProps = ({auth}) => {
  const {loader, alertMessage, showMessage, authUser} = auth;
  return {loader, alertMessage, showMessage, authUser}
};

export default connect(mapStateToProps, {
  userSignUp,
  hideMessage,
  showAuthLoader,
  userFacebookSignIn,
  userGoogleSignIn,
  userGithubSignIn,
  userTwitterSignIn
})(WrappedSignUpForm);
